module.exports = __webpack_public_path__ + "static/swipeToUnlock-6bf76b07bdc051fd4ebd076121ebc1cc.png";